module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "hInfo1",
    attrs: {
      "model": _vm.hInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "pGuid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目guid"
    },
    model: {
      value: (_vm.hInfo1.pGuid),
      callback: function($$v) {
        _vm.hInfo1.pGuid = $$v
      },
      expression: "hInfo1.pGuid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题，如205题提示一、二等"
    },
    model: {
      value: (_vm.hInfo1.title),
      callback: function($$v) {
        _vm.hInfo1.title = $$v
      },
      expression: "hInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提示级别"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "提示级别，正整数"
    },
    model: {
      value: (_vm.hInfo1.hLevel),
      callback: function($$v) {
        _vm.hInfo1.hLevel = $$v
      },
      expression: "hInfo1.hLevel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveHint
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("提示内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container-jtgc"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar-container-jtgc"
    }
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-font"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-size"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-italic"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-underline"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-strike"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-color"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-background"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-blockquote"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-code-block"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-align"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-link"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-image"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-video"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-formula"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-clean"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "editor-container-jtgc"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c35bf3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hintDlg/src/main.vue
// module id = 648
// module chunks = 2